import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { supabase } from '../lib/supabase'
import { apiRequest } from '../services/api'

const PROFILE_COLS = 'id, name, phone, email, profile_photo_url, role, status, department, is_active, auth_id'

export const useStaffAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            profile: null,
            session: null,
            loading: false,

            login: async (email, password) => {
                set({ loading: true })
                const { data, error } = await supabase.auth.signInWithPassword({ email, password })
                if (error) { set({ loading: false }); throw error }

                // Exchange for backend JWT
                try {
                    const jwt = await apiRequest('POST', '/auth/exchange', {
                        supabase_token: data.session.access_token,
                        email: data.user.email,
                    })
                    if (jwt?.token) {
                        localStorage.setItem('staff_jwt', jwt.token)
                    }
                } catch (e) {
                    // non-blocking — backend JWT is only needed for writes
                }

                // Fetch profile from users table (limited columns)
                const { data: profile } = await supabase
                    .from('users')
                    .select(PROFILE_COLS)
                    .eq('auth_id', data.user.id)
                    .single()

                set({ user: data.user, session: data.session, profile, loading: false })
                return profile
            },

            logout: async () => {
                await supabase.auth.signOut()
                localStorage.removeItem('staff_jwt')
                set({ user: null, session: null, profile: null })
            },

            refreshProfile: async () => {
                const { user } = get()
                if (!user) return
                const { data } = await supabase
                    .from('users')
                    .select(PROFILE_COLS)
                    .eq('auth_id', user.id)
                    .single()
                set({ profile: data })
            },

            isAdmin: () => {
                const { profile } = get()
                return profile?.role === 'ADMIN' || profile?.role === 'MANAGER'
            },
        }),
        {
            name: 'abhaflow-auth',
            partialize: (s) => ({ user: s.user, session: s.session, profile: s.profile }),
        }
    )
)
